import { render, staticRenderFns } from "./AlertaEmail.vue?vue&type=template&id=33da2acb&"
import script from "./AlertaEmail.vue?vue&type=script&lang=js&"
export * from "./AlertaEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports